module.exports = __webpack_public_path__ + "assets/media/carousel_1.922a9412.svg";